const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPeople(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m183.272 209.548h73.017 73.017c7.931 0 14.354-6.449 14.354-14.413v-15.707c0-41.193-32.713-76.769-77.285-76.769 23.539-4.706 41.286-25.557 41.286-50.584 0-28.485-23.004-51.574-51.372-51.574s-51.372 23.089-51.372 51.574c0 25.027 17.747 45.878 41.286 50.584-44.514 0-77.285 35.521-77.285 76.769v15.707c.001 7.963 6.423 14.413 14.354 14.413z",
    fill: "#ffffff",
    "data-original": "#000000",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "m64.518 249.767c.908.166 1.809.246 2.7.246 7.1 0 13.407-5.09 14.724-12.354 3.689-20.354 10.673-40.131 20.757-58.78 9.732-17.997 21.936-34.159 36.273-48.036 5.958-5.766 6.132-15.291.389-21.274-5.743-5.982-15.228-6.157-21.186-.391-16.547 16.017-30.615 34.637-41.811 55.343-11.603 21.458-19.646 44.252-23.905 67.75-1.481 8.175 3.918 16.008 12.059 17.496z",
    fill: "#ffffff",
    "data-original": "#000000",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "m409.88 178.878c10.084 18.65 17.068 38.426 20.757 58.78 1.317 7.265 7.623 12.354 14.724 12.354.89 0 1.793-.08 2.7-.246 8.141-1.488 13.54-9.321 12.058-17.496-4.259-23.498-12.302-46.293-23.905-67.75-11.196-20.706-25.264-39.327-41.811-55.343-5.958-5.767-15.443-5.591-21.186.391-5.743 5.983-5.568 15.507.389 21.274 14.338 13.877 26.542 30.039 36.274 48.036z",
    fill: "#ffffff",
    "data-original": "#000000",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "m316.821 364.681c-19.328 6.379-39.685 9.649-60.531 9.719-.27.01-.549.01-.819.01-20.387 0-40.364-3.059-59.353-9.087-7.891-2.508-16.302 1.885-18.799 9.809s1.878 16.369 9.769 18.876c21.915 6.961 44.919 10.491 68.383 10.491h.819c24.033-.09 47.536-3.862 69.881-11.234 7.861-2.588 12.146-11.093 9.559-18.987-2.577-7.892-11.048-12.195-18.909-9.597z",
    fill: "#ffffff",
    "data-original": "#000000",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "m97.455 404.61c23.54-4.707 41.288-25.565 41.288-50.584 0-28.485-23.004-51.584-51.372-51.584s-51.372 23.099-51.372 51.584c0 25.019 17.748 45.877 41.288 50.584-44.476 0-77.287 35.485-77.287 76.77v15.707c0 7.954 6.423 14.413 14.354 14.413h73.017 73.017c7.931 0 14.354-6.459 14.354-14.413v-15.707c0-41.111-32.624-76.77-77.287-76.77z",
    fill: "#ffffff",
    "data-original": "#000000",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "m434.713 404.61c23.54-4.707 41.288-25.565 41.288-50.584 0-28.485-23.004-51.584-51.372-51.584-28.378 0-51.372 23.099-51.372 51.584 0 25.019 17.741 45.877 41.285 50.584-44.578 0-77.285 35.568-77.285 76.769v15.707c0 7.954 6.423 14.413 14.354 14.413h73.017 73.017c7.921 0 14.354-6.459 14.354-14.413v-15.706c.001-41.197-32.714-76.77-77.286-76.77z",
    fill: "#ffffff",
    "data-original": "#000000",
    style: {}
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeople);
export default __webpack_public_path__ + "static/media/people.9dd6dba5f03b6bc6e097d845763800b2.svg";
export { ForwardRef as ReactComponent };